import React from 'react';

export const ToastGroupContext = React.createContext({ isInToastGroup: false });
